import { QueryParamValue } from '@/lib/http/queryParamsBuilder';

const DEFAULT_URL_PARAMS = {
  page: 1,
  limit: 10,
  orderBy: 'boughtCounter',
  sort: 'desc'
};

function normalizeQueryValue(value: QueryParamValue): string[] {
  if (value === undefined || value === null) {
    return [];
  }
  if (Array.isArray(value)) {
    return value.map(String);
  }
  return [String(value)];
}

function normalizeAndCompare(value1: QueryParamValue, value2: QueryParamValue): boolean {
  const norm1 = normalizeQueryValue(value1);
  const norm2 = normalizeQueryValue(value2);

  if (norm1.length !== norm2.length) {
    return false;
  }
  for (let i = 0; i < norm1.length; i++) {
    if (norm1[i] !== norm2[i]) {
      return false;
    }
  }
  return true;
}

export const getFormattedFilteredParams = (
  selectedFilters: Record<string, QueryParamValue>,
  defaultOrderBy?: string,
  defaultSort?: string
): Record<string, string> => {
  const formattedParams: Record<string, string> = {};

  for (const [key, rawValue] of Object.entries(selectedFilters)) {
    const normalized = normalizeQueryValue(rawValue);
    const stringified = normalized.join(',');

    if (normalized.length === 0) continue;

    if (key === 'orderBy' && normalizeAndCompare(normalized, defaultOrderBy)) {
      continue;
    }

    if (key === 'sort' && normalizeAndCompare(normalized, defaultSort)) {
      continue;
    }

    if (key === 'page') {
      const pageValue = Number(normalized[0]);
      if (pageValue === DEFAULT_URL_PARAMS.page) continue;
    }

    formattedParams[key] = stringified;
  }

  return formattedParams;
};
